module.exports = __webpack_public_path__ + "img/MA-HMI-2.e8ba6cb9.png";